import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const GiftCardLink = ({ link, className, text }) => (
  <Link
    className={cx('c-btn c-btn--secondary c-btn--secondary-multiline u-1/1', className)}
    to={link}
  >
    {text}
  </Link>
);

GiftCardLink.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

GiftCardLink.defaultProps = {
  className: '',
};

export default GiftCardLink;



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardLink/GiftCardLink.jsx